export const BASE_URL = "https://apidesignsbysakhi.q4hosting.com/api";
//export const BASE_URL = "http://localhost:2404/api";
   // export const BASE_URL = "https://srv22.synques.in:1721/api";
   
   
   